// extracted by mini-css-extract-plugin
export default {"taskPanel":"TaskPanel_taskPanel__ZejR8","review":"TaskPanel_review__FQYZe","taskPanel_ios":"TaskPanel_taskPanel_ios__bSpN9","content":"TaskPanel_content__-F2Fm"};